module.exports = __webpack_public_path__ + "media/application/images/primate-2535f771840630067d44dc145c3af0c0.png";